import "core-js/features/object/assign.js";
import "core-js/features/array/find.js";
import "core-js/features/array/find-index.js";
import "core-js/features/array/fill.js";
import "core-js/features/array/includes.js";
import "core-js/features/array/from.js";
import "core-js/features/promise/index.js";
import "core-js/features/promise/finally.js";
import "core-js/features/symbol";

// window.fetch
import "whatwg-fetch";

// for react 16
// https://facebook.github.io/react/blog/2017/09/26/react-v16.0.html#javascript-environment-requirements
import "core-js/features/map/index.js";
import "core-js/features/set/index.js";
